/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ApplicationFormViewModel } from './ApplicationFormViewModel';
import {
    ApplicationFormViewModelFromJSON,
    ApplicationFormViewModelFromJSONTyped,
    ApplicationFormViewModelToJSON,
} from './ApplicationFormViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfApplicationFormViewModel
 */
export interface ResultOfApplicationFormViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfApplicationFormViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfApplicationFormViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfApplicationFormViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfApplicationFormViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfApplicationFormViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfApplicationFormViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfApplicationFormViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {ApplicationFormViewModel}
     * @memberof ResultOfApplicationFormViewModel
     */
    data?: ApplicationFormViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfApplicationFormViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfApplicationFormViewModel interface.
 */
export function instanceOfResultOfApplicationFormViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfApplicationFormViewModelFromJSON(json: any): ResultOfApplicationFormViewModel {
    return ResultOfApplicationFormViewModelFromJSONTyped(json, false);
}

export function ResultOfApplicationFormViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfApplicationFormViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ApplicationFormViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfApplicationFormViewModelToJSON(value?: ResultOfApplicationFormViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': ApplicationFormViewModelToJSON(value.data),
        'Count': value.count,
    };
}

